import { useEffect } from "react";

import AdminHome from "../components/APanel/AdminHome";
import PreloadAppData from "../components/Utils/PreloadAppData";

function MPanel() {
   useEffect(() => {
      document.title = "Instruire Auto | MPanel";
   }, []);

   return (
      <>
         <PreloadAppData />
         <main className="main">
            <AdminHome />
         </main>
      </>
   );
}

export default MPanel;
